<template>
	<div class="home" v-cloak>
		<!--轮播部分-->
		<Banner v-if="home.banner.length>0" :data="home.banner"/>
		<!--关于我们-->
		<!-- <AboutUs v-if="home.about" :data="home.about"/> -->
		<!--最新动态-->
		<Trends v-if="home.bestNews.length>0" :data="home.bestNews"/>
		<!--产品展示-->
		<Services v-if="home.bestProduct.length>0" :data="home.bestProduct"/>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex';
	import Banner from '@/components/home/Banner.vue'
	import AboutUs from '@/components/home/AboutUs.vue'
	import Trends from '@/components/home/Trends.vue'
	import Services from '@/components/home/Services.vue'
	import mixins from '@/assets/mixins/mixins.js'
	export default {
		name: "home",
		mixins: [mixins],
		created() {
			this.initHome();
		},
		computed:{
			...mapGetters(['home'])
		},
		methods:{
			...mapActions(['initHome'])
		},
		components:{
			Banner,
			AboutUs,
			Trends,
			Services
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/home.vue